import { gql } from '@apollo/client';

export default gql`
  mutation deleteTodo($id: ID!) {
    deleteTodo(_id: $id) {
      payload {
        _id
        title
        item
      }
      message
      status
    }
  }
`;
